<!-- Main Page Start -->
<section class="pd-tb-2 search-page">
    <div class="container">
        <div class="search-home">
            <div class="row">
                <div class="col-md-4 col-lg-4 col-sm-12">
                    <div class="white-box filters-wrap">
                        <h4 class="filter-heading"> Filters </h4>                        
                            <div class="filter-heading button"> <button type="submit" class="apply-btn planbtn fill" (click)="applyFilter()" > Apply </button> 
                            <a href="javascript:void(0);" (click)="onClearFilters()" class="clear-all "> Clear  All</a>
                            </div>
                        <!--  accordion  -->
                        <!-- 1 -->
                        <div class="accordion-drawer">
                            <input class="accordion-drawer__trigger" id="accordion-drawer" type="checkbox" />
                            <label class="accordion-drawer__title" for="accordion-drawer">Location & Salary </label>
                            <div class="accordion-drawer__content-wrapper">
                                <div class="accordion-drawer__content">
                                    <div class="form-group">
                                        <label> Location </label>
                                        <input ngx-google-places-autocomplete [options]='options'
                                            [(ngModel)]="selectedFilters.location"
                                            (onAddressChange)="onAddressChange($event)" type="text"
                                            placeholder="Location" class="form-control">
                                    </div>
                                    <div class="price-slider-wrap">
                                        <label> Desired salary </label>
                                        <div class="range"> 
                                            <ngx-slider [(value)]="sliderMin" [(highValue)]="sliderMax" [options]="sliderOptions">
                                            </ngx-slider>
                                        </div>
                                        <!-- <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Min </label>
                                                    <input type="number" name="" placeholder="Min"
                                                        [(ngModel)]="selectedFilters.minimum"
                                                        (input)="onDesiredSalaryChange($event,'minimum')"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Max </label>
                                                    <input type="number" name="" placeholder="Max"
                                                        [(ngModel)]="selectedFilters.maximum"
                                                        (input)="onDesiredSalaryChange($event,'maximum')"
                                                        class="form-control">
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="row mt-3 ">
                                            <div class="col-lg-6">
                                                <div class="radioWrap">
                                                    <input type="radio" id="Hour" (change)="onPayoutTypeChange($event)"
                                                        name="salaryType" value="Per hour"
                                                        [(ngModel)]="selectedFilters.rate" />
                                                    <label for="Hour"> Per Hour </label>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="radioWrap">
                                                    <input type="radio" id="day" (change)="onPayoutTypeChange($event)"
                                                        name="salaryType" value="Per day"
                                                        [(ngModel)]="selectedFilters.rate" />
                                                    <label for="day"> Per Day </label>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="radioWrap">
                                                    <input type="radio" id="week" (change)="onPayoutTypeChange($event)"
                                                        name="salaryType" value="Per week"
                                                        [(ngModel)]="selectedFilters.rate" />
                                                    <label for="week"> Per Week </label>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="radioWrap">
                                                    <input type="radio" id="month" (change)="onPayoutTypeChange($event)"
                                                        name="salaryType" value="Per month"
                                                        [(ngModel)]="selectedFilters.rate" />
                                                    <label for="month"> Per Month </label>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="radioWrap">
                                                    <input type="radio" id="annum" (change)="onPayoutTypeChange($event)"
                                                        name="salaryType" value="Per year"
                                                        [(ngModel)]="selectedFilters.rate" />
                                                    <label for="annum"> Per Annum </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 2 -->
                        <div class="accordion-drawer" *ngIf="filterOptions?.workPlace.length">
                            <input class="accordion-drawer__trigger" id="accordion-drawer-1" type="checkbox" /><label
                                class="accordion-drawer__title" for="accordion-drawer-1"> Work Place </label>
                            <div class="accordion-drawer__content-wrapper">
                                <div class="accordion-drawer__content">
                                    <div class="row">
                                        <div *ngFor="let option of filterOptions?.workPlace; let i = index;"
                                            class="col-lg-6">
                                            <div class="checkboxWrap">
                                                <input type="checkbox"
                                                (change)="onFilterOptionChange($event,option,'workPlaceLocation')" id="workplace{{i}}" value="{{option.id}}"
                                                [checked]="toggleFilterChekbox(option.id,'workPlaceLocation')" />
                                            <label for="workplace{{i}}"> {{option.name}} </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="accordion-drawer" *ngIf="filterOptions?.employmentTypes.length">
                            <input class="accordion-drawer__trigger" id="accordion-drawer-2" type="checkbox" /><label
                                class="accordion-drawer__title" for="accordion-drawer-2"> Employment Type </label>
                            <div class="accordion-drawer__content-wrapper">
                                <div class="accordion-drawer__content">
                                    <div class="row">
                                        <div *ngFor="let option of filterOptions?.employmentTypes; let i = index;"
                                            class="col-lg-6">
                                            <div class="checkboxWrap">
                                                <input type="checkbox"  (change)="onFilterOptionChange($event,option,'employementTypeId')"
                                                id="employment{{i}}" value="{{option.id}}"
                                                [checked]="toggleFilterChekbox(option.id,'employementTypeId')" />
                                            <label for="employment{{i}}"> {{option.name}}</label>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 3 -->
                        <div class="accordion-drawer" *ngIf="filterOptions?.categories.length">
                            <input class="accordion-drawer__trigger" id="accordion-drawer-3" type="checkbox" /><label
                                class="accordion-drawer__title" for="accordion-drawer-3">Category</label>
                            <div class="accordion-drawer__content-wrapper">
                                <div class="accordion-drawer__content">
                                    <div class="row">
                                        <div *ngFor="let option of filterOptions?.categories; let i = index;"
                                            class="col-lg-6">
                                            <div class="checkboxWrap">
                                                <input type="checkbox"
                                                    (change)="onFilterOptionChange($event,option,'categoryId')"
                                                    id="category{{i}}" value="{{option.id}}"
                                                    [checked]="toggleFilterChekbox(option.id,'categoryId')" />
                                                <label for="category{{i}}"> {{option.name}} </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Sub-category-->
                        <div class="accordion-drawer" *ngIf="subCatOptions?.length">
                            <input class="accordion-drawer__trigger" id="accordion-drawer-31" type="checkbox" /><label
                                class="accordion-drawer__title" for="accordion-drawer-31">Sub-Category</label>
                            <div class="accordion-drawer__content-wrapper">
                                <div class="accordion-drawer__content">
                                    <div class="row">
                                        <div *ngFor="let option of subCatOptions; let i = index;"
                                            class="col-lg-6">
                                            <div class="checkboxWrap">
                                                <input type="checkbox"
                                                    (change)="onFilterOptionChange($event,option,'subCategories')"
                                                    id="subCategory{{i}}" value="{{option.id}}"
                                                    [checked]="toggleFilterChekbox(option.id,'subCategories')" />
                                                <label for="subCategory{{i}}"> {{option.name}} </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 4 -->
                        <div class="accordion-drawer" *ngIf="filterOptions?.industry.length">
                            <input class="accordion-drawer__trigger" id="accordion-drawer-4" type="checkbox" /><label
                                class="accordion-drawer__title" for="accordion-drawer-4">Industry</label>
                            <div class="accordion-drawer__content-wrapper">
                                <div class="accordion-drawer__content">
                                    <div class="row">
                                        <div *ngFor="let option of filterOptions?.industry; let i = index;"
                                            class="col-lg-6">
                                            <div class="checkboxWrap">
                                                <input type="checkbox"
                                                (change)="onFilterOptionChange($event,option,'industryId')"
                                                id="industry{{i}}" value="{{option.id}}"
                                                [checked]="toggleFilterChekbox(option.id,'industryId')" />
                                                <label for="industry{{i}}"> {{option.name}} </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 5 -->
                        <div class="accordion-drawer" *ngIf="filterOptions?.eligible.length">
                            <input class="accordion-drawer__trigger" id="accordion-drawer-5" type="checkbox" /><label
                                class="accordion-drawer__title" for="accordion-drawer-5">Veteran status </label>
                            <div class="accordion-drawer__content-wrapper">
                                <div class="accordion-drawer__content">
                                    <div class="row">
                                        <div *ngFor="let option of filterOptions?.eligible; let i = index;"
                                            class="col-lg-6">
                                            <div class="checkboxWrap">
                                                <input type="checkbox"
                                                (change)="onFilterOptionChange($event,option,'jobEligibleForId')"
                                                id="veteran{{i}}" value="{{option.id}}"
                                                [checked]="toggleFilterChekbox(option.id,'jobEligibleForId')" />
                                                <label for="veteran{{i}}" class="cap"> {{option.name}} </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 6 -->
                        <div class="accordion-drawer" *ngIf="filterOptions?.personalities.rows.length">
                            <input class="accordion-drawer__trigger" id="accordion-drawer-6" type="checkbox" /><label
                                class="accordion-drawer__title" for="accordion-drawer-6">Personalities </label>
                            <div class="accordion-drawer__content-wrapper">
                                <div class="accordion-drawer__content">
                                    <div class="row">
                                        <div *ngFor="let option of this.filterOptions?.personalities?.rows; let i = index;"
                                            class="col-lg-6">
                                            <div class="checkboxWrap">
                                                <input type="checkbox"
                                                    (change)="onFilterOptionChange($event,option,'personalitiesIds')"
                                                    id="personalities{{i}}" value="{{option.id}}"
                                                    [checked]="toggleFilterChekbox(option.id,'personalitiesIds')" />
                                                <label for="personalities{{i}}"> {{option.title}} ({{option.count || 0 }}) </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 7 -->
                        <div class="accordion-drawer" *ngIf="filterOptions?.benefits.length">
                            <input class="accordion-drawer__trigger" id="accordion-drawer-7" type="checkbox" /><label
                                class="accordion-drawer__title" for="accordion-drawer-7"> Benefits </label>
                            <div class="accordion-drawer__content-wrapper">
                                <div class="accordion-drawer__content">
                                    <div class="row">
                                        <div *ngFor="let option of filterOptions?.benefits; let i = index;"
                                            class="col-lg-6">
                                            <div class="checkboxWrap">
                                                <input type="checkbox"
                                                    (change)="onFilterOptionChange($event,option,'benefitsId')"
                                                    id="benefits{{i}}" value="{{option.id}}"
                                                    [checked]="toggleFilterChekbox(option.id,'benefitsId')" />
                                                <label for="benefits{{i}}"> {{option.name}} </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="jobs col-md-8 col-lg-8 col-sm-12">
                    <div class=" sub-heading sub-heading2">
                        <h4 class="d-flex"> <div class="boldFont">
                            {{totalJobsCount}} Results found for <span class=" text-orange">
                                ({{searchKey}})
                            </span>
                        </div>
                            <div class="dropdown dropdown-user nav-item" ngbDropdown>
                                <a href="javascript:void(0);" class="clear-all sort-btn dropdown-toggle"
                                    data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
                                    id="dropdown_profile_area" ngbDropdownToggle [ngClass]="showRedDot ? 'active':''">
                                    <img src="assets/images/ic_sort.svg" class="ic_sort "> Sort By <span></span> </a>
                                <ul class="dropdown-menu ml-3 dropdown-menu-right dropdown-menu-animated profile-dropdown  dropdown-arrow sortingDrop"
                                    ngbDropdownMenu aria-labelledby="dropdown_profile_area">
                                    <li>
                                        <a class="dropdown-item" href="javascript:;"
                                            (click)="onSorting('Alphabetical')">
                                            Alphabetical
                                            (A to
                                            Z) </a>
                                    </li>
                                    <li><a class="dropdown-item" href="javascript:;" (click)="onSorting('maximum')">
                                            Highest Salary </a></li>
                                    <li><a class="dropdown-item" href="javascript:;" (click)="onSorting('createdAt')">
                                            Newly posted </a></li>
                                    <li><a class="dropdown-item" href="javascript:;" (click)="onSorting('ending')">
                                            Ending soon </a></li>
                                </ul>
                            </div>
                        </h4>
                    </div>
                    <!-- <div class="infinite-scroll onSearchScroll" id="style-1" infinite-scroll [infiniteScrollDistance]="2"
                        [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onModalScrollDown()"  *ngIf="jobs.length > 0"> -->
                        <div *ngFor="let job of jobs | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index;">
                            <div>
                               
                                <app-search-applied-save-jobs-list [job]="job" [routerLink]="'/detail/' + job?._id" [queryParams]="{type: 'search',extras:filtersIntoString}"
                                    (onJobSaved)="onJobSaved($event)"></app-search-applied-save-jobs-list>
                            </div>
                        </div>
                        
                        <div class="col-sm-12 p-0" *ngIf="jobs?.length > 0">
                            <ul class="pagination ">
                                <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                            </ul>
                        </div>
                    <!-- </div> -->
                    
                    <div class="search-results h-4" *ngIf="jobs.length == 0">
                        <div class="no-results">
                            <img src="../../../assets/images/ic_serech_empty.svg" />
                            <h6 class="pt-3">No Data Found</h6>
                            <p>Select relevant filters and hit search to view search results</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End -->